
import { useT } from 'apprise-frontend-core/intl/language'
import { useUpgrade } from 'apprise-frontend-events/context'
import { Button } from 'apprise-ui/button/button'
import './upgradebutton.scss'

export const UpgradeButton = () => {

    const t = useT()

    const {stale} = useUpgrade().get()

    return stale &&

        <Button noReadonly className='upgradebutton' size='small' tipPlacement='bottom' tip={t('bus.upgrade_btn_tooltip')} onClick={() => window.location.reload()}>
            {t('bus.upgrade_btn')}
        </Button>

}